import { api } from './api';

const OPP_RX = /^OPP?[A-Z]{0,4}\d{3,}$/i;

export const oppNumberOf = (p) => {
  const num = (p.opp_number || '').trim();
  if (num) return num;
  const name = (p.name || '').trim();
  return OPP_RX.test(name) ? name : '';
};

// Pulls the opportunity name from NetSuite for projects that only have a number.
export async function fillOppNames(items, apply) {
  const ids = (items || [])
    .filter(p => !(p.opp_name || '').trim() && oppNumberOf(p))
    .map(p => p.id).slice(0, 40);
  if (!ids.length) return;
  try {
    const r = await api.projectOppNames(ids);
    const byId = {};
    (r.items || []).forEach(x => { byId[x.id] = x; });
    if (Object.keys(byId).length) apply(byId);
  } catch (e) { /* NetSuite unreachable — the opportunity number still shows */ }
}

// Searchable by project/opportunity name, opportunity number or client.
export function projectMatches(p, q) {
  const needle = (q || '').trim().toLowerCase();
  if (!needle) return true;
  return [p.name, p.opp_name, p.opp_number, p.client]
    .some(v => (v || '').toLowerCase().includes(needle));
}
